export const MIN_DIFICULTY = 10;
export const DAMANE_MOD = 2;
